import Logo from 'assets/svg/logo-ralali-big/logo-ralali-big.svg'
import LayoutAuth from 'common/components/LayoutAuth'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import MediaHelper from 'lib/media-helper'
import ResetPasswordFlow from 'services/Auth/components/ResetPasswordFlow'
import MetaData from 'services/Auth/screens/ForgotPassword/MetaData'
import styled from 'styled-components'

const WrapperLogo = styled.a`
  cursor: pointer;
  z-index: ${theme.zIndex.dropdown};
  display: flex;
  justify-content: center;
  text-decoration: none;
  margin-top: 40px;

  ${MediaHelper('laptop')`svg {display: none;}`}
`

function ForgotPassword({ lang }: { lang: string }): JSX.Element {
  return (
    <LayoutAuth lang={lang} metaData={<MetaData />}>
      <WrapperLogo href={`${WEB_DESKTOP_RALALI_URL}`}>
        <Logo />
      </WrapperLogo>
      <ResetPasswordFlow responsive />
    </LayoutAuth>
  )
}

export default ForgotPassword
